"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewCard = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var NewCard_st_css_1 = require("./NewCard.st.css");
var dataHooks_1 = require("./dataHooks");
var Container = function (props) {
    var className = props.className, children = props.children, minWidth = props.minWidth;
    return (React.createElement("div", { style: { flexBasis: minWidth }, className: classnames_1.default(NewCard_st_css_1.classes.container, className), "data-hook": props['data-hook'] || dataHooks_1.NEWCARD_DATA_HOOKS.NewCardContainer }, children));
};
/** An implementation of NewCard for TPAs */
var NewCard = /** @class */ (function (_super) {
    __extends(NewCard, _super);
    function NewCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewCard.prototype.getDataAttributes = function () {
        var _a;
        var stacked = this.props.stacked;
        return _a = {},
            _a[dataHooks_1.NEWCARD_DATA_KEYS.Stacked] = stacked,
            _a;
    };
    NewCard.prototype.render = function () {
        var _a = this.props, stacked = _a.stacked, children = _a.children, className = _a.className;
        return (React.createElement("section", __assign({ "data-hook": this.props['data-hook'], className: NewCard_st_css_1.st(NewCard_st_css_1.classes.root, { stacked: stacked }, className) }, this.getDataAttributes()), children));
    };
    NewCard.displayName = 'NewCard';
    NewCard.defaultProps = {
        stacked: false,
    };
    NewCard.Container = Container;
    return NewCard;
}(React.Component));
exports.NewCard = NewCard;
//# sourceMappingURL=NewCard.js.map